import script from "./PropertyNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyNavBar.vue?vue&type=script&setup=true&lang=js"

import "./PropertyNavBar.vue?vue&type=style&index=0&id=28a39857&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a39857"]])

export default __exports__